// Copyright (C) 2019 TANNER AG

import React, { useContext, useState } from "react";
import { withStyles } from "@material-ui/core";
import { Module } from "../module";
import * as PropTypes from "prop-types";
import { withStore } from "../../store/withstore";
import { RangeSlider } from "../../components/rangeslider";
import { TranslationContext } from "../../translation";

const MIN = 0.4;
const MAX = 2;
const STEP = 0.1;

const sliderStyles = {
	label: {
		display: "block",
		color: "#e40045",
		fontSize: "18px",
		lineHeight: "25px",
		textAlign: "center",
		fontFamily: "MANEurope, Arial, sans-serif",
		fontWeight: "bold",
		fontStretch: "condensed"
	}
};

const FuelPriceSlider = withStyles(sliderStyles)(({ value, formatted, setValue, classes }) => {
	const { format } = useContext(TranslationContext);
	return (
		<div style={{ width: 300 }}>
			<span className={classes.label}>{format(value || MIN, true)}</span>
			<RangeSlider
				onChange={setValue}
				value={value || MIN}
				min={MIN}
				max={MAX}
				step={STEP}
			/>
		</div>
	);
});

const FuelPrice = (props) => {
	const { store: { a, b }, storeAction } = props;
	const [valueA, setValueA] = useState(a.fuelPrice);
	const [valueB, setValueB] = useState(b.fuelPrice);
	const { format } = useContext(TranslationContext);

	return (
		<Module
			id={props.id}
			activeModule={props.activeModule}
			nextModule={props.nextId}
			onActivate={props.setActiveModule}
			final={props.final}
			label="module.fuelprice.title"
			title="module.fuelprice.query"
			valueA={format(valueA, true)}
			valueB={format(valueB, true)}
			continueEnabled={valueA !== null && valueB !== null}
			onContinue={() => storeAction.setFuelPrice(valueA, valueB)}
			queryA={<FuelPriceSlider value={valueA} setValue={setValueA}/>}
			queryB={<FuelPriceSlider value={valueB} setValue={setValueB}/>}
		/>
	);
};

FuelPrice.propTypes = {
	id: PropTypes.string.isRequired,
	nextId: PropTypes.string.isRequired,
	activeModule: PropTypes.string,
	setActiveModule: PropTypes.func
};

export default withStore(FuelPrice);



// WEBPACK FOOTER //
// ./src/tco/configuration/modules/fuelprice.js